import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root"
})
export class GrupoService {
  public url: string;
  public identity;
  public token;

  constructor(public _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  signup(user, getToken = null): Observable<any> {
    if (getToken != null) {
      user.getToken = "true";
    }
    let json = encodeURIComponent(JSON.stringify(user));
    let params = "json=" + json;

    let headers = new HttpHeaders().set(
      "Content-Type",
      "application/x-www-form-urlencoded"
    );
    // Url del back
    return this._http.post(this.url + "login", params, { headers: headers });
  }

  getGrupo(token, id): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "grupos/" + id, { headers: headers });
  }

  getGrupos(token): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.get(this.url + "grupos", { headers: headers });
  }

  create(token, grupo): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(grupo));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.post(this.url + "grupos", params, { headers: headers });
  }

  changePassword(info): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(info));
    let params = "json=" + json;
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
    // Url del back
    return this._http.post(this.url + "change_password", params, {
      headers: headers
    });
  }

  delete(token, id): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    return this._http.delete(this.url + "grupos/" + id, { headers: headers });
  }

  update(token, id, grupo): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(grupo));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.put(this.url + "grupos/" + id, params, {
      headers: headers
    });
  }

  remember_password(info): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(info));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
    // Url del back
    return this._http.post(this.url + "remember_password", params, {
      headers: headers
    });
  }

  validateCode(code): Observable<any> {
    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
    return this._http.get(this.url + "validateCode/" + code, { headers: headers });
  }

  actualizar(token, id, grupo): Observable<any> {
    let json = encodeURIComponent(JSON.stringify(grupo));
    let params = "json=" + json;

    let headers = new HttpHeaders()
      .set("Content-Type", "application/x-www-form-urlencoded")
      .set("Authorization", token);
    // Url del back
    return this._http.put(this.url + "grupos/" + id, params, {
      headers: headers
    });
  }

  getToken() {
    let token = localStorage.getItem("token");
    if (token != "undefined") {
      this.token = token;
    } else {
      this.token = null;
    }
    return this.token;
  }

  getIdentity() {
    let identity = JSON.parse(localStorage.getItem("identity"));
    if (identity != "undefined") {
      this.identity = identity;
    } else {
      this.identity = null;
    }

    return this.identity;
  }
}
